import React from 'react';

export interface CircularProgressProps {
  size?: number | string;
  color?: 'primary' | 'secondary' | 'inherit';
  thickness?: number;
  className?: string;
}

const CircularProgress: React.FC<CircularProgressProps> = ({
  size = 40,
  color = 'primary',
  thickness = 3.6,
  className = '',
}) => {
  const colorClasses = {
    primary: 'text-primary',
    secondary: 'text-secondary',
    inherit: 'text-current',
  };

  const sizeValue = typeof size === 'number' ? `${size}px` : size;

  return (
    <div
      className={`inline-block animate-spin ${colorClasses[color]} ${className}`}
      style={{ width: sizeValue, height: sizeValue }}
    >
      <svg className="w-full h-full" viewBox="0 0 50 50">
        <circle
          className="opacity-25"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="currentColor"
          strokeWidth={thickness}
        />
        <circle
          className="opacity-75"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="currentColor"
          strokeWidth={thickness}
          strokeDasharray="80 200"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default CircularProgress;
